<template>
  <el-dialog
    :title="isCreate ? '新增加盟商' : '编辑加盟商'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="商家登录名" prop="vendorLoginAccount">
        <el-input v-model.trim="ruleForm.vendorLoginAccount"></el-input>
      </el-form-item>
      <template v-if="isCreate">
        <el-form-item label="密码" prop="password">
          <el-input
            v-model.trim="ruleForm.password"
            maxlength="16"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repeatpassword">
          <el-input
            v-model.trim="ruleForm.repeatpassword"
            maxlength="16"
            type="password"
          ></el-input>
        </el-form-item>
      </template>
      <el-form-item label="商家名称" prop="vendorName">
        <el-input v-model.trim="ruleForm.vendorName"></el-input>
      </el-form-item>
      <el-form-item label="商家联系人" prop="vendorContact">
        <el-input v-model.trim="ruleForm.vendorContact"></el-input>
      </el-form-item>
      <el-form-item label="商家手机" prop="vendorMobile">
        <el-input v-model.trim="ruleForm.vendorMobile"></el-input>
      </el-form-item>
      <el-form-item label="所在城市" prop="vendorCity">
        <el-select v-model="ruleForm.vendorCity" placeholder="请选择">
          <el-option
            v-for="(item, index) in CITY_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理商" prop="agentid" v-if="userType === 'admin'">
        <el-select v-model="ruleForm.agentid" placeholder="请选择">
          <el-option
            v-for="(item, index) in agentList"
            :key="index"
            :label="item.agentName"
            :value="item.agentid"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button type="warning" v-if="!isCreate" @click="resetPassword()"
          >重置密码</el-button
        >
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import enumObject from "../../../plugins/enum";
//import { mapGetters } from "vuex";
export default {
  props: ["isCreate", "editInfo"],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("validatePass2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        vendorLoginAccount: this.editInfo
          ? this.editInfo.vendorLoginAccount
          : "",
        password: "",
        repeatpassword: "",
        vendorName: this.editInfo ? this.editInfo.vendorName : "",
        vendorContact: this.editInfo ? this.editInfo.vendorContact : "",
        vendorMobile: this.editInfo ? this.editInfo.vendorMobile : "",
        vendorCity: this.editInfo ? this.editInfo.vendorCity : "",
        agentid: this.editInfo ? this.editInfo.agentid : ""
      },
      rules: {
        vendorLoginAccount: [{ required: true, message: "请输入商家登录名" }],
        password: [
          { required: true, validator: validatePass },
          {
            pattern: /^.*(?=.{6,16})(?=.*[0-9a-zA-Z]{1,})(?=.*[!@#$%^&*?()]).*$/,
            message: "密码必须6-16位，至少包含1个特殊字符(!@#$%^&*)"
          }
        ],
        repeatpassword: [{ required: true, validator: validatePass2 }],
        vendorName: [{ required: true, message: "请输入商家名称" }],
        vendorContact: [{ required: true, message: "请输入商家联系人" }],
        vendorMobile: [
          { required: true, message: "请输入商家手机" },
          {
            validator: (rule, value, callback) => {
              if (!/^1\d{10}$/.test(value)) {
                return callback(new Error("请输入正确的手机号码"));
              } else {
                return callback();
              }
            }
          }
        ],
        vendorCity: [{ required: true, message: "请输入所在城市" }],
        agentid: [{ required: true, message: "请输入代理商名称" }]
      },
      agentList: [],
      userType: this.$getUserType()
    };
  },
  methods: {
    generatePassword(length) {
      var result = "";
      var characters =
        "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789"; //去除0O1l等易混淆字符
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    resetPassword() {
      const _password = this.generatePassword(7) + "!";
      this.$confirm("密码将重置为【" + _password + "】,是否继续？", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs["ruleForm"].validate(valid => {
            if (valid) {
              let queryModel = {
                vendorPassword: _password,
                id: this.editInfo.id
              };
              this.$axios(this.$urlMapping["编辑加盟商"], {
                data: queryModel
                // eslint-disable-next-line no-unused-vars
              }).then(result => {
                this.$message({
                  message: `密码已重置成功，初始密码为：${_password}`,
                  type: "success",
                  showClose: true,
                  duration: 0
                });
                this.$emit("closeForm");
                this.$emit("handleUpdate");
              });
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let queryModel = {
            vendorLoginAccount: this.isCreate
              ? this.ruleForm.vendorLoginAccount
              : undefined,
            vendorName: this.ruleForm.vendorName,
            vendorPassword: this.isCreate ? this.ruleForm.password : undefined,
            vendorContact: this.ruleForm.vendorContact,
            vendorMobile: this.ruleForm.vendorMobile,
            vendorCity: this.ruleForm.vendorCity,
            agentid: this.ruleForm.agentid,
            id: this.isCreate ? undefined : this.editInfo.id
          };
          let key = this.isCreate ? "新增加盟商" : "编辑加盟商";
          this.$axios(this.$urlMapping[key], {
            data: queryModel
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.$getAllVendorIDName(); //刷新全局数据

            this.$emit("closeForm");
            this.$emit("handleUpdate");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    },
    queryAgent() {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询代理商"], {
          data: {}
        }).then(result => {
          this.agentList = result.data;
          resolve();
        });
      });
    }
  },
  computed: {
    CITY_ENUM() {
      return enumObject.CITY_ENUM.filter(ele => ele.value != "");
    }
  },
  async mounted() {
    if (this.userType === "admin") {
      await this.queryAgent();
    }
  }
};
</script>

<style lang="less" scoped></style>
